import {getEnv} from '../../common/env/env';
import {WelcomeRecommendDto} from '../../common/shared/api/gateway/welcome/WelcomeRecommendDto.interface';
import {getKageUrl} from '../../common/shared/utils/getKageUrl';
import {WelcomeRecommendItem} from '../generated/types';

export function createWelcomeRecommendItem({
  series_id,
  title,
  category,
  sub_category,
  view_count,
  free_slide_count,
  thumbnail,
  authors,
  theme_keyword_list,
  description,
}: WelcomeRecommendDto): WelcomeRecommendItem {
  return {
    seriesId: series_id,
    scheme: `kakaopage://open/content?series_id=${series_id}`,
    thumbnail: thumbnail.startsWith('http')
      ? thumbnail
      : getKageUrl({
          kageUrlPrefix: getEnv().kageUrlPrefix,
          kageId: thumbnail,
          resolution: 'th3',
        }),
    title,
    category,
    subCategory: sub_category,
    viewCount: view_count,
    freeSlideCount: free_slide_count,
    authors,
    themeKeywordList: theme_keyword_list,
    description,
  };
}
